module.exports = __webpack_public_path__ + "static/media/LeaseListingShortage.4f4152f7.svg";